const useMakeContactOrderDto = (
  options?: GraphqlMutationOptions<MakeContactOrderMutation, MakeContactOrderMutationVariables>,
) => {
  const mutation = useGraphqlMutation(MakeContactOrderSchema, options);

  return {
    ...mutation,
  };
};

export { useMakeContactOrderDto };
